
import { Component, Vue, Prop } from "nuxt-property-decorator";
import { HeaderData } from "~/types/components";

@Component
export default class TheLogo extends Vue {
  @Prop() headerData!: HeaderData;
}
